import {Header} from "./Header"
import {StatCards, StatCardsProps} from "./StatCards"
import {Box, ScrollArea} from "@mantine/core";
import {ProtocolTable} from "./ProtocolTable";
import classes from "./Dashboard.module.css"
import cx from "clsx";
import {useNeurotuneStore} from "../../../common/store/neurotune";
import {useDashboardStore} from "./store";
import dayjs from "dayjs";
import {useEffect, useState} from "react";


export const Dashboard: React.FC = () => {
    const activeCompany = useNeurotuneStore((state) => state.activeCompany)
    const stats = useDashboardStore((state) => state.protocolDefStats)
    const loadProtocolDefStats = useDashboardStore((state) => state.loadProtocolDefStats)
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        loadProtocolDefStats(activeCompany.id)
    }, [])

    const cardStats: StatCardsProps = stats.reduce((agg, stat) => {
        agg.stimStepCount += stat.stimCount
        agg.totalStimTime = agg.totalStimTime.add(dayjs.duration({seconds:stat.totalStimSeconds}))
        agg.megScanCount += stat.megScanCount
        agg.totalMegScanDuration = agg.totalMegScanDuration.add(dayjs.duration({seconds:stat.totalMEGSeconds}))
        agg.eegScanCount += stat.eegScanCount
        agg.totalEegScanDuration = agg.totalEegScanDuration.add(dayjs.duration({seconds:stat.totalEEGSeconds}))
        agg.sessionCount += stat.sessionCount
        agg.completedCount += stat.completedCount
        return agg
    }, {
        stimStepCount: 0,
        totalStimTime: dayjs.duration(0),
        megScanCount: 0,
        totalMegScanDuration: dayjs.duration(0),
        eegScanCount: 0,
        totalEegScanDuration: dayjs.duration(0),
        sessionCount: 0,
        completedCount: 0,
    } as StatCardsProps)

    return (
        <Box className={cx(classes.root)}>
            <ScrollArea className={cx(classes.scrollarea)}
                        onScrollPositionChange={({y}) => setScrolled(y !== 0)}
            >
                <Box className={cx(classes.content)}>
                    <Header title={"Protocol Activity Dashboard"}
                            subtitle={"Monitor and analyse research protocols in real-time"}/>
                    <StatCards {...cardStats}/>
                    <ProtocolTable stats={stats.filter((stat) => stat.sessionCount !== 0)}/>
                </Box>
            </ScrollArea>
        </Box>
    )
}